import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  Users,
  Briefcase,
  Package,
  FileText,
  Receipt,
  Settings,
  LogOut,
  HardDrive,
  X,
  ClipboardList,
} from 'lucide-react';
import { useAuthStore } from '../../auth/authStore';
import { NetworkStatusBadge } from './NetworkStatusBadge';

const navItems = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/clientes', label: 'Clientes', icon: Building2 },
  { to: '/empleados', label: 'Empleados', icon: Users },
  { to: '/servicios', label: 'Servicios', icon: Briefcase },
  { to: '/refacciones', label: 'Refacciones', icon: Package },
  { to: '/soporte-diario', label: 'Soporte Diario', icon: ClipboardList },
  { to: '/relaciones', label: 'Relaciones de Soporte', icon: FileText },
  { to: '/facturas', label: 'Facturas', icon: Receipt },
  { to: '/sync', label: 'Sincronización', icon: HardDrive },
];

export function Sidebar({ open, onClose }) {
  const usuario = useAuthStore((s) => s.usuario);
  const logout = useAuthStore((s) => s.logout);

  return (
    <>
      <div
        onClick={onClose}
        className={`fixed inset-0 bg-black/60 z-30 md:hidden transition-opacity ${
          open ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      />
      <aside
        className={`w-64 bg-panel border-r border-border flex flex-col h-full
                    fixed inset-y-0 left-0 z-40 transform transition-transform duration-200
                    md:relative md:translate-x-0
                    ${open ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="px-5 py-5 border-b border-border flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/VVSOLUTIONS_LOGO.png"
              alt="VVSOLUTIONS"
              className="h-10 w-auto"
            />
            <div>
              <h1 className="font-bold text-white text-sm tracking-wider">VVSRS</h1>
            </div>
          </div>
          <button
            onClick={onClose}
            className="md:hidden p-1.5 rounded text-slate-400 hover:text-white hover:bg-panel-2"
            title="Cerrar menú"
          >
            <X size={18} />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto px-2 py-3 space-y-0.5">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition ${
                  isActive
                    ? 'bg-cyan-500/10 text-cyan-400 border-l-2 border-cyan-400'
                    : 'text-slate-300 hover:bg-panel-2 hover:text-white'
                }`
              }
            >
              <item.icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-border p-3 space-y-2">
          <div className="hidden md:block">
            <NetworkStatusBadge />
          </div>
          <div className="flex items-center gap-2 px-2 py-2 rounded-md bg-panel-2">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center text-white text-xs font-bold">
              {usuario?.nombreCompleto?.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase() || 'US'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-white truncate">{usuario?.nombreCompleto || usuario?.username}</p>
              <p className="text-[10px] text-muted">{usuario?.rol}</p>
            </div>
            <button
              onClick={logout}
              className="p-1.5 rounded text-slate-400 hover:text-rose-400 hover:bg-rose-500/10"
              title="Cerrar sesión"
            >
              <LogOut size={14} />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
